var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./malli.impl.util.js");
'use strict';